/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getInitialState, VISUAL_SLICE_NAME } from './constants';

export const buildDetailsSlice = createSlice({
  name: VISUAL_SLICE_NAME,
  initialState: getInitialState(),
  reducers: {
    setDiffIds: (state, action: PayloadAction<string[]>) => {
      state.allDiffIds = action.payload;
    },
    resetState: (state) => {
      const initialState = getInitialState();
      state.allDiffIds = initialState.allDiffIds;
      state.haveItemsChanged = false;
    },
    setItemsChanged: (state, action: PayloadAction<boolean>) => {
      state.haveItemsChanged = action.payload;
    },
  },
});

const { actions, reducer } = buildDetailsSlice;

export {
  actions,
};

export default reducer;
